import angular, { IPromise } from "angular";
import { IQueryResponse } from "../../../../server/query";
import { SubFilter } from "./subFilters";

export type ServerQuery<T> = (search: string) => IPromise<IQueryResponse<T>>;

export class LookupFilter extends SubFilter {
  private readonly valueField: string;
  private readonly displayField: string;
  private currentOptions: unknown[] = [];
  private readonly serverQuery: ServerQuery<unknown>;

  constructor(config: {
    displayName: string;
    queryFieldNames: string[];
    valueField?: string;
    displayField?: string;
    serverQuery: ServerQuery<unknown>;
  }) {
    super(config);

    this.serverQuery = config.serverQuery;
    this.valueField = config.valueField || "Id";
    this.displayField = config.displayField || "Name";
  }

  query(search: string) {
    this.serverQuery(search).then((result) => {
      this.currentOptions = result.Results;
    });

    // this.recordServer.executeOperation<any>(this.sourceOperation, {
    //   recordDefinition: this.sourceOperation.recordDefinition,
    //   requestModel: query
    // })
    //   .then(queryResponse => {
    //     const results = queryResponse.Results
    //     this.currentOptions = results
    //   })
  }

  getGui(): angular.IAugmentedJQuery {
    return angular.element(`
    <ui-select ng-model="${this.getQueryFieldExpression()}">
    <ui-select-match allow-clear="true">{{$select.selected[subFilterController.displayField]}}</ui-select-match>
    <ui-select-choices repeat="option[subFilterController.valueField] as option in subFilterController.currentOptions"
      refresh="subFilterController.query($select.search)"
      refresh-delay="500">
      <div>
          {{option[subFilterController.displayField]}}
      </div>
    </ui-select-choices>
  </ui-select>
    `);
  }
}
